import seoMeta from '@/config/seo-meta';

export const useHandlePageSeoMeta = async ({
  pageData = {},
  pageError = {},

  withErrorHandling = false,
  sectionsMustExist = false,
} = {}) => {
  const { locale } = useI18n();
  const url = useRequestURL();

  // Error handling
  if (withErrorHandling && pageError.value) {
    const { statusCode, statusMessage } = pageError.value;
    throw createError({ statusCode, statusMessage, fatal: true });
  }

  // Data null handling
  if (sectionsMustExist && !pageData.value?.sections) {
    throw createError({ statusCode: 404, fatal: true });
  }

  const defaultCanonical = `${url?.origin}${url?.pathname}`;

  useSeo({
    url,

    title: () => pageData.value?.meta?.title || seoMeta.title,
    description: () => pageData.value?.meta?.description || seoMeta.description,
    image: () => pageData.value?.meta?.image?.original || '',
    // keywords: () => pageData.value?.meta?.keywords || '',
    robots: () => pageData.value?.meta?.robots || '',
    canonical: () => pageData.value?.meta?.canonical || defaultCanonical,
    locale: () => locale.value || '',
  });
};
